$ = require 'jquery'
Auth = require 'db/auth'
Browser = require '@trello/browser'
TeamBannerComponent = require 'views/member/team-banner-component'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
Storage = require 'lib/storage'
View = require 'view'
_ = require 'underscore'
recup = require 'recup'
templates = require 'views/internal/templates'

TIP_ANDROID = {
  key: 'tip-download app'
  url: 'https://play.google.com/store/apps/details?id=com.trello'
  imgAlt: 'tip-google play'
  imgSrc: require('images/buttons/btn-playstore.png')
}
TIP_IOS = {
  key: 'tip-download app'
  url: 'https://itunes.apple.com/app/trello-organize-anything/id461504587'
  imgAlt: 'tip-app store'
  imgSrc: require('images/buttons/btn-appstore.png')
}

module.exports = class TeamBannerView extends View
  initialize: ->
    @listenTo Auth.me(),
      'change:oneTimeMessagesDismissed': @frameDebounce @render

  getReactRoot: ->
    React.createElement ReactRootComponent, {}, @getTeamBanner()

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  render: ->
    @$reactRoot ?= $('<div></div>')
    @$el.append(@$reactRoot)
    @renderReactSection()

    @

  getTeamBanner: ->
    { bannerToDisplay, idBannersToDismiss } = @options

    dismissBanners = =>
      idBannersToDismiss.forEach (idBanner) => @model.dismiss(idBanner)

    isAndroid = Browser.isAndroid()
    isIos = Browser.isIos()

    lastTipsIndex = bannerToDisplay.tips.length - 1

    if isAndroid
      bannerToDisplay.tips[lastTipsIndex] = TIP_ANDROID
    else if isIos
      bannerToDisplay.tips[lastTipsIndex] = TIP_IOS

    recup.render => recup.div =>
      recup.createElement TeamBannerComponent, _.extend({
        onDismissBanner: dismissBanners
      }, bannerToDisplay)

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/member/team-banner-view.coffee